import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './auth.service';
import { NoAccessComponent } from './no-access.component';
import { focusHeadingOnNavigation } from './focus-heading';

@Component({
  selector: 'mng-root',
  imports: [NoAccessComponent, RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (auth.accessFailure(); as failure) {
      <mng-no-access [reason]="failure" />
    } @else if (auth.identity(); as me) {
      @if (me.internal) {
        <router-outlet />
      } @else {
        <mng-no-access reason="not-staff" />
      }
    }
  `,
})
export class AppComponent {
  protected readonly auth = inject(AuthService);

  constructor() {
    focusHeadingOnNavigation();
  }
}
